import React from 'react';
import c from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

import { MAIL_INFOLEP } from '../../../../config/constants';

const SearchOcularDBResultsEmptyState: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchOcularDB__Results__EmptyState');

  return (
    <div className={classNames}>
      <h2 className="asH3">{t('components.search_oculardb.empty_state.title')}</h2>
      <p>
        <Trans i18nKey="components.search_oculardb.empty_state.body">
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
          <a href={`mailto: ${MAIL_INFOLEP}`} aria-label="e-mail address" />
        </Trans>
      </p>
    </div>
  );
};

export default SearchOcularDBResultsEmptyState;
